import RichText from "./RichText";
function slugify(title) {
  return title
    .toLowerCase()
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/å/g, "a")
    .replace(/[^a-z0-9 ]/g, "") // remove punctuation
    .trim()
    .replace(/\s+/g, "-"); // spaces to dashes
}

function formatPrice(raw) {
  if (!raw) return "";
  return raw.toString().replace(/(\d)(€)/g, "$1 €");
}

export default function PricesTable({ prices }) {
  return (
    <div className="py-4 max-w-4xl mx-auto">
      {prices.map((section, index) => (
        <div key={index} className="mb-10">
          {section.title && (
            <h2
              className="text-2xl font-bold mb-1 scroll-mt-24"
              id={slugify(section.title)}
            >
              {section.title}
            </h2>
          )}
          {section.note && (
            <RichText
              className="text-sm text-gray-600 mb-3 text-block"
              value={section.note}
            />
          )}
          <table className="w-full text-left border-t border-b border-gray-200">
            <tbody>
              {section.items?.map((item, i) => (
                <tr
                  key={i}
                  className="border-t border-gray-100 even:bg-gray-50"
                >
                  <td className="px-1 py-3 pr-4 align-top">
                    <div className="font-semibold">{item.title}</div>
                    {item.description && (
                      <div className="text-sm">{item.description}</div>
                    )}
                  </td>
                  <td className="px-1 py-3 text-nowrap whitespace-nowrap font-semibold text-right align-top">
                    {formatPrice(item.price)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
